import Input from 'component/atom/forms/input/input/Input';
import Toggle from 'component/atom/forms/toggle/Toggle';
import React from 'react';
import styles from './fields.module.scss';
import { useFormikContext } from 'formik';
import MultiSelectList from 'component/atom/forms/select/multi-select-list/MultiSelectList';
import Select from 'component/atom/forms/select/select/Select';

const AttachmentField = ({ index, field }) => {
  const formik = useFormikContext();

  const stringsToArray = React.useMemo(() => {
    if (Array.isArray(field.typeSelection)) return field.typeSelection;
    if (typeof field.typeSelection === 'string')
      return field.typeSelection
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean);
    return [];
  }, [field.typeSelection]);

  return (
    <div className={`${styles['field']} ${styles['attachment']}`}>
      <Input
        label='Input Label'
        placeholder='Enter Label'
        name={`formDetails[${index}].fieldLabel`}
        value={field.fieldLabel}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={
          formik.touched.formDetails?.[index]?.fieldLabel &&
          formik.errors.formDetails?.[index]?.fieldLabel
        }
        touched={
          formik.touched.formDetails?.[index]?.fieldLabel &&
          formik.errors.formDetails?.[index]?.fieldLabel
        }
      />
      <Input
        label='Input Placeholder'
        placeholder='Enter Placeholder'
        name={`formDetails[${index}].placeHolder`}
        value={field.placeHolder}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={
          formik.touched.formDetails?.[index]?.placeHolder &&
          formik.errors.formDetails?.[index]?.placeHolder
        }
        touched={
          formik.touched.formDetails?.[index]?.placeHolder &&
          formik.errors.formDetails?.[index]?.placeHolder
        }
      />
      <div className={styles['fieldContainer']}>
        <Input
          label='Max Size (MB)'
          placeholder='Enter '
          name={`formDetails[${index}].characterLimit`}
          value={field.characterLimit}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={
            formik.touched.formDetails?.[index]?.characterLimit &&
            formik.errors.formDetails?.[index]?.characterLimit
          }
          touched={
            formik.touched.formDetails?.[index]?.characterLimit &&
            formik.errors.formDetails?.[index]?.characterLimit
          }
        />
        <MultiSelectList
          label='File Type'
          placeholder='Select Type'
          name={`formDetails[${index}].typeSelection`}
          value={stringsToArray}
          onChange={(e) => {
            const selected = e.target.value.join(',');
            formik.setFieldValue(
              `formDetails[${index}].typeSelection`,
              selected,
            );
          }}
          onBlur={formik.handleBlur}
          error={
            formik.touched.formDetails?.[index]?.typeSelection &&
            formik.errors.formDetails?.[index]?.typeSelection
          }
          touched={
            formik.touched.formDetails?.[index]?.typeSelection &&
            formik.errors.formDetails?.[index]?.typeSelection
          }
          options={[
            {
              label: 'pdf',
              value: 'pdf',
            },
            {
              label: 'docx',
              value: 'docx',
            },
            {
              label: 'xls',
              value: 'xls',
            },
            {
              label: 'png',
              value: 'png',
            },
            {
              label: 'jpg',
              value: 'jpg',
            },
            {
              label: 'txt',
              value: 'txt',
            },
          ]}
        />
        <Toggle
          label='Required'
          left={true}
          name={`formDetails[${index}].isMandatory`}
          value={field.isMandatory}
          onChange={(e) =>
            formik.setFieldValue(
              `formDetails[${index}].isMandatory`,
              e.target.value,
            )
          }
          style={{ flexDirection: 'column' }}
        />
      </div>
    </div>
  );
};

export default AttachmentField;
